export default (url, params = {}) =>
  Object.keys(params).reduce(
    (acc, name) => acc.replace(`{${name}}`, `${params[name]}`),
    url
  );
